import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#6451D9",
      light: "rgba(100, 81, 217, 0.49)",
      dark: "rgba(100, 81, 217, 1)",
    },
    secondary: {
      main: "#D9C750",
    },
  },
});

export default theme;
